<template>
  <div class="links">
    <a
      v-for="(link, index) in linkObjects"
      class="text -t3 link"
      :class="link.classes"
      :href="link.url"
      :key="link.linkText + index"
      target="_blank"
      ref="links"
    >{{ link.linkText }}</a>
  </div>
</template>

<script>
  import throttle from 'lodash/throttle'

  export default {
    props: {
      links: Array
    },
    data() {
      return {
        linkObjects: []
      }
    },
    mounted() {
      this.$set(this, 'linkObjects', JSON.parse(JSON.stringify(this.links)));
      this.$nextTick(() => {
        this.resize();
        window.addEventListener('resize', this.resize);
      })
    },
    methods: {
      resize: throttle(function() {

        let maxWidth = this.$el.offsetWidth,
          totalWidth = 0;

        this.$refs.links.forEach((link, i) => {
          let currentWidth = link.offsetWidth,
          nextWidth = this.$refs.links[i+1] ? this.$refs.links[i+1].offsetWidth : 0;


          totalWidth += currentWidth;

          if (((totalWidth + nextWidth) > maxWidth) || this.$refs.links.length-1 == i) {

            this.$set(this.linkObjects[i], 'classes', '-last')
            totalWidth = 0;
          } else {
            this.$set(this.linkObjects[i], 'classes', '')
          }
        });
      }, 100)
    }
  }
</script>

<style lang="scss" scoped>
  .links {
    text-align: center;
  }
  .link {
    padding: 0 .4em;
    display: inline-block;
    text-align: center;
    border-right: 1px solid #00205B;
    &.-last {
      border-right: 0;
    }
  }
</style>
